module.exports = __webpack_public_path__ + "static/media/24.725df63b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/24.png
// module id = 877
// module chunks = 0